import { render, staticRenderFns } from "./MatchResultsSelect.vue?vue&type=template&id=6b9e18a6"
import script from "./MatchResultsSelect.vue?vue&type=script&lang=js"
export * from "./MatchResultsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports